import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
//import Footer from "components/Footer/Footer.js";
import CustomFooter from "components/CustomFooter/CustomFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//import Card from "components/Card/Card.js";
//import CardBody from "components/Card/CardBody.js";
//import CardHeader from "components/Card/CardHeader.js";
//import Button from "components/CustomButtons/Button.js";
import blogApi from "services/blogApi.js";
import "assets/css/blog-content.css";

const useStyles = makeStyles((theme) => ({
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
    minHeight: "100vh",
  },
  container: {
    paddingTop: "96px",
    paddingBottom: "50px",
    paddingLeft: "16px",
    paddingRight: "16px",
    maxWidth: "800px",
    margin: "0 auto",
    color: "#3f444b",
    [theme.breakpoints.up('sm')]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: "0px",
      paddingRight: "0px",
    },
  },
  backLink: {
    marginBottom: "30px",
    display: "flex",
  },
  backButton: {
    backgroundColor: "transparent",
    color: "#f7931e",
    "&:hover": {
      color: "#f7931eaa",
      backgroundColor: "transparent",
    },
    padding: "4px",
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  postCard: {
    boxShadow: "none",
    border: "none",
    backgroundColor: "transparent",
  },
  postTitle: {
    fontFamily: "'Adelle-sans', 'Helvetica Neue', Arial, sans-serif",
    fontSize: "28px",
    fontWeight: "700",
    lineHeight: "1.3em",
    letterSpacing: "-0.3px",
    marginBottom: "20px",
    color: "#3f444b",
    [theme.breakpoints.up('sm')]: {
      fontSize: "36px",
    },
    [theme.breakpoints.up('md')]: {
      fontSize: "44px",
    },
  },
  featuredImage: {
    width: "100%",
    height: "auto",
    maxHeight: "400px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "30px",
  },
  postMeta: {
    fontSize: "0.875rem",
    color: "#999",
    marginBottom: "30px",
    borderBottom: "1px solid #eee",
    paddingBottom: "15px",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
  },
  postMetaContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  primaryCategory: {
    position: "relative",
    top: "0",
    right: "0",
    display: "block",
    backgroundColor: "#f7931e",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    fontWeight: "500",
    order: "2",
  },
  authorSection: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    gap: "10px",
  },
  authorAvatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  authorAvatarClickable: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    objectFit: "cover",
    cursor: "pointer",
    transition: "opacity 0.3s ease",
    "&:hover": {
      opacity: 0.8,
    },
  },
  authorName: {
    fontWeight: "500",
    color: "#666",
  },
  authorNameClickable: {
    fontWeight: "500",
    color: "#666",
    cursor: "pointer",
    textDecoration: "none",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#f7931e",
      textDecoration: "none",
    },
  },
  tagsSection: {
    marginTop: "10px",
  },
  tag: {
    display: "inline-block",
    backgroundColor: "#f0f0f0",
    color: "#666",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    marginRight: "6px",
    marginBottom: "4px",
  },
  keywordsSection: {
    marginTop: "10px",
  },
  keyword: {
    display: "inline-block",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    marginRight: "6px",
    marginBottom: "4px",
    border: "1px solid #bbdefb",
  },
  postContent: {
    "& .blog-content": {
      "& p": {
        color: "#999999",
        fontSize: "16px",
      },
      "& a": {
        color: "#61b4e4",
        textDecoration: "none",
        "&:hover": {
          color: "#61b4e4aa",
        },
        "&:visited": {
          color: "#4a8fc4",
        },
      },
    },
  },
  loadingText: {
    textAlign: "center",
    fontSize: "1.2rem",
    color: "#999",
    marginTop: "100px",
  },
  errorText: {
    textAlign: "center",
    fontSize: "1.2rem",
    color: "#f44336",
    marginTop: "100px",
  },
  notFoundText: {
    textAlign: "center",
    fontSize: "1.5rem",
    color: "#999",
    marginTop: "100px",
  },
  relatedPostsSection: {
    marginTop: "60px",
    paddingTop: "40px",
    borderTop: "1px solid #eee",
  },
  relatedPostsTitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
    marginBottom: "30px",
    color: "#3f444b",
    [theme.breakpoints.up('sm')]: {
      fontSize: "1.6rem",
    },
    [theme.breakpoints.up('md')]: {
      fontSize: "1.8rem",
    },
  },
  relatedPostCard: {
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    marginBottom: "20px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  relatedPostImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    borderRadius: "6px",
    marginBottom: "12px",
  },
  relatedPostPlaceholder: {
    width: "100%",
    height: "150px",
    backgroundColor: "#f5f5f5",
    borderRadius: "6px",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    fontSize: "0.8rem",
  },
  relatedPostTitle: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#3f444b",
    textDecoration: "none",
    lineHeight: "1.3",
    marginBottom: "8px",
    "&:hover": {
      color: "#f7931e",
      textDecoration: "none",
    },
  },
  relatedPostMeta: {
    fontSize: "0.75rem",
    color: "#999",
  },
}));

/* 
"& span": {
          textDecoration: "none",
          color: "#61b4e4",
        },

        */

export default function BlogPost() {
  const classes = useStyles();
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [isRelated, setIsRelated] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await blogApi.getPostBySlug(slug);

        if (response.success) {
          setPost(response.data);

          // Fetch related posts
          try {
            const relatedResponse = await blogApi.getRelatedPosts(
              response.data.id,
              3
            );
            if (relatedResponse.success) {
              setRelatedPosts(relatedResponse.data);
              setIsRelated(relatedResponse.is_related);
            }
          } catch (relatedErr) {
            console.error("Error fetching related posts:", relatedErr);
            // Don't set error state for related posts failure
          }
        } else {
          throw new Error(response.message || "Failed to fetch post");
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching post:", err);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPost();
    }
  }, [slug]);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const getSocialMediaImage = (featuredImage) => {
    // If there's a featured image, ensure it's an absolute URL
    if (featuredImage) {
      // If it's already an absolute URL, return as is
      if (featuredImage.startsWith('http://') || featuredImage.startsWith('https://')) {
        return featuredImage;
      }
      // If it's a relative URL, make it absolute
      return `${window.location.origin}${featuredImage.startsWith('/') ? '' : '/'}${featuredImage}`;
    }
    
    // Fallback to a default WeVett Realty image for social media
    // You should replace this with your actual default social media image URL
    return `${window.location.origin}/img/wevett-social-default.jpg`;
  };

  // SEO: Update document meta tags when post loads
  useEffect(() => {
    if (post) {
      // Update document title
      document.title = `${post.title} - WeVett Realty Blog`;

      // Update meta description
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          post.excerpt ||
            post.description ||
            `Read ${post.title} on WeVett Realty Blog`
        );
      } else {
        const newMetaDescription = document.createElement("meta");
        newMetaDescription.name = "description";
        newMetaDescription.content =
          post.excerpt ||
          post.description ||
          `Read ${post.title} on WeVett Realty Blog`;
        document.head.appendChild(newMetaDescription);
      }

      // Update meta keywords
      const allKeywords = [
        ...(post.keywords ? post.keywords.map((keyword) => keyword.name) : []),
        ...(post.tags ? post.tags.map((tag) => tag.name) : []),
      ];

      if (allKeywords.length > 0) {
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        const keywordContent = allKeywords.join(", ");

        if (metaKeywords) {
          metaKeywords.setAttribute("content", keywordContent);
        } else {
          const newMetaKeywords = document.createElement("meta");
          newMetaKeywords.name = "keywords";
          newMetaKeywords.content = keywordContent;
          document.head.appendChild(newMetaKeywords);
        }
      }

      // Get the social media image (featured image or fallback)
      const socialImage = getSocialMediaImage(post.featured_image);
      
      // Update Open Graph tags
      updateOrCreateMetaTag("og:title", post.title);
      updateOrCreateMetaTag(
        "og:description",
        post.excerpt ||
          post.description ||
          `Read ${post.title} on WeVett Realty Blog`
      );
      updateOrCreateMetaTag("og:type", "article");
      updateOrCreateMetaTag("og:url", window.location.href);
      updateOrCreateMetaTag("og:image", socialImage);
      updateOrCreateMetaTag("og:image:width", "1200");
      updateOrCreateMetaTag("og:image:height", "630");
      updateOrCreateMetaTag("og:image:alt", post.title);
      updateOrCreateMetaTag("og:site_name", "WeVett Realty Blog");

      // Update Twitter Card tags
      updateOrCreateMetaTag("twitter:card", "summary_large_image");
      updateOrCreateMetaTag("twitter:title", post.title);
      updateOrCreateMetaTag(
        "twitter:description",
        post.excerpt ||
          post.description ||
          `Read ${post.title} on WeVett Realty Blog`
      );
      updateOrCreateMetaTag("twitter:image", socialImage);
      updateOrCreateMetaTag("twitter:image:alt", post.title);

      // Add JSON-LD structured data
      addJsonLdStructuredData(post, socialImage);
    }
  }, [post]);

  const updateOrCreateMetaTag = (property, content) => {
    let metaTag =
      document.querySelector(`meta[property="${property}"]`) ||
      document.querySelector(`meta[name="${property}"]`);
    if (metaTag) {
      metaTag.setAttribute("content", content);
    } else {
      metaTag = document.createElement("meta");
      if (property.startsWith("og:") || property.startsWith("twitter:")) {
        metaTag.setAttribute("property", property);
      } else {
        metaTag.setAttribute("name", property);
      }
      metaTag.setAttribute("content", content);
      document.head.appendChild(metaTag);
    }
  };

  const addJsonLdStructuredData = (post, socialImage) => {
    // Remove existing JSON-LD script if it exists
    const existingScript = document.querySelector(
      'script[type="application/ld+json"]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: post.title,
      description:
        post.excerpt ||
        post.description ||
        `Read ${post.title} on WeVett Realty Blog`,
      image: [socialImage],
      datePublished: post.created_at,
      dateModified: post.updated_at,
      author: post.author
        ? {
            "@type": "Person",
            name: post.author.name,
            url: post.author.profile_url || undefined,
          }
        : {
            "@type": "Organization",
            name: "WeVett Realty",
          },
      publisher: {
        "@type": "Organization",
        name: "WeVett Realty",
        url: "https://wevettrealty.com",
        logo: {
          "@type": "ImageObject",
          url: `${window.location.origin}/img/wevett-logo.png`
        }
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": window.location.href,
      },
      keywords: [
        ...(post.keywords ? post.keywords.map((keyword) => keyword.name) : []),
        ...(post.tags ? post.tags.map((tag) => tag.name) : []),
      ].join(", "),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
  };

  const renderContent = () => {
    if (loading) {
      return <div className={classes.loadingText}>Loading post...</div>;
    }

    if (error) {
      return (
        <div className={classes.errorText}>Error loading post: {error}</div>
      );
    }

    if (!post) {
      return <div className={classes.notFoundText}>Post not found.</div>;
    }

    return (
      <div className={classes.postCard}>
        {post.featured_image && (
          <img
            src={post.featured_image}
            alt={post.title}
            className={classes.featuredImage}
          />
        )}

        <h1 className={classes.postTitle}>{post.title}</h1>

        <div className={classes.postMeta}>
          
          <div className={classes.postMetaContent}>
            {post.author && (
              <div className={classes.authorSection}>
                {post.author.avatar &&
                  (post.author.profile_url ? (
                    <a
                      href={post.author.profile_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={post.author.avatar}
                        alt={post.author.name}
                        className={classes.authorAvatarClickable}
                      />
                    </a>
                  ) : (
                    <img
                      src={post.author.avatar}
                      alt={post.author.name}
                      className={classes.authorAvatar}
                    />
                  ))}
                {post.author.profile_url ? (
                  <a
                    href={post.author.profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.authorNameClickable}
                  >
                    By {post.author.name}
                  </a>
                ) : (
                  <span className={classes.authorName}>
                    By {post.author.name}
                  </span>
                )}
              </div>
            )}
            <div>
              Published: {formatDate(post.created_at)}
              {post.updated_at !== post.created_at && (
                <span> | Updated: {formatDate(post.updated_at)}</span>
              )}
            </div>
            {post.tags && post.tags.length > 0 && (
              <div className={classes.tagsSection}>
                {post.tags.map((tag) => (
                  <span key={tag.id} className={classes.tag}>
                    {tag.name}
                  </span>
                ))}
              </div>
            )}
          </div>

          {post.categories && post.categories.length > 0 && (
            <div className={classes.postMetaContent}>
              <div className={classes.primaryCategory}>
                {post.categories[0].name}
              </div>
            </div>
          )}
        </div>

        <div
          className={`${classes.postContent} blog-content`}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        {relatedPosts.length > 0 && (
          <div className={classes.relatedPostsSection}>
            <h2 className={classes.relatedPostsTitle}>
              {isRelated ? "Related Posts" : "Recent Posts"}
            </h2>
            <GridContainer>
              {relatedPosts.map((relatedPost) => (
                <GridItem xs={12} sm={6} md={4} key={relatedPost.id}>
                  <div className={classes.relatedPostCard}>
                    <Link
                      to={`/blog/post/${relatedPost.slug}`}
                      style={{ textDecoration: "none" }}
                    >
                      {relatedPost.featured_image ? (
                        <img
                          src={relatedPost.featured_image}
                          alt={relatedPost.title}
                          className={classes.relatedPostImage}
                        />
                      ) : (
                        <div className={classes.relatedPostPlaceholder}>
                          No Image
                        </div>
                      )}

                      <h3 className={classes.relatedPostTitle}>
                        {relatedPost.title}
                      </h3>

                      <div className={classes.relatedPostMeta}>
                        {formatDate(relatedPost.created_at)}
                      </div>
                    </Link>
                  </div>
                </GridItem>
              ))}
            </GridContainer>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <Header
        brand="WeVett Realty"
        links={<HeaderLinks dropdownHoverColor="primary" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 80,
          color: "secondary",
        }}
      />

      <div className={classes.main}>
        <div className={classes.container}>
          <div className={classes.backLink}>
            <Link to="/blog">
              <div className={classes.backButton}>
                <i class="fa-solid fa-angle-left"></i>
                <span>Back to Blog</span>
              </div>
            </Link>
          </div>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              {renderContent()}
            </GridItem>
          </GridContainer>
        </div>
      </div>

      <CustomFooter />
    </div>
  );
}
